import { db } from "../../../service/API";

export class ProfileAccessConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
  }

  getListAccess() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileAccessConnector/listAccess/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get list access failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get list access " + err.message);
        });
    });
  }

  insertAccessData(accessObject) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileAccessConnector/insertAccessData/", {
        sid: this.socId,
        accessObject: accessObject,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insert access failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on insert access data : " + err.message);
        });
    });
  }

  updateAccessData(accessObject, rid) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileAccessConnector/updateAccessData/", {
        rid: rid,
        accessObject: accessObject,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve();
          } else {
            return reject("update access failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on update access data : " + err.message);
        });
    });
  }

  deleteAccessData(rid) {
    return new Promise((resolve, reject) => {
      db.delete("/ProfileAccessConnector/deleteAccessData/", {
        rid: rid,
        sid: this.socId,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else {
            return reject("delete access failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("delete access failed with error : " + err.message);
        });
    });
  }
}
